import React, { useMemo } from 'react';
import { getDeviationTitle } from '../../../DeviationViews/_helpers';
import GroupCard from '../../../GroupCard';
import { BiLoggerContextProvider } from '../../../biLogger/BiLogger.context';
import { BiEventType } from '../../../biLogger/constants';
import SidebarBlock from '../../_partials/SidebarBlock';
import { ResourceType } from '../../../types/resource';
import Placeholder from '../../_partials/Placeholder';
import s from './GroupsBlock.scss';
export var GroupsBlock = function (_a) {
    var _b = _a.deviation, author = _b.author, extended = _b.extended, deviation = _a.deviation, _c = _a.groups, groups = _c === void 0 ? [] : _c, showGroupsListPopup = _a.showGroupsListPopup, isLoading = _a.isLoading;
    var deviationTitle = getDeviationTitle(deviation);
    var authorUuid = author && author.useridUuid;
    var groupListUrl = extended && extended.groupListUrl;
    var seeAll = useMemo(function () { return ({
        onClick: groupListUrl
            ? function () { return showGroupsListPopup(groupListUrl, deviationTitle); }
            : undefined,
        biData: {
            creatorid: authorUuid,
        },
    }); }, [groupListUrl, deviationTitle, authorUuid, showGroupsListPopup]);
    if (!groups.length && !isLoading) {
        return null;
    }
    return (React.createElement(BiLoggerContextProvider, { value: { sectionname: 'groups' } },
        React.createElement(SidebarBlock, { streamKey: "groups", className: s['root'], seeAll: seeAll, isLoading: isLoading },
            React.createElement("div", { className: s['grid'] },
                !isLoading &&
                    groups
                        .filter(function (group) { return !!group; }) // backend can do strange stuff...
                        .slice(0, 4)
                        .map(function (group, index) { return (React.createElement(GroupCard, { key: group.userId, username: group.username, imageUrl: group.usericon, userId: group.userId, className: s['grid-item'], biData: {
                            evid: BiEventType.USERNAME_CLICK,
                            typeid: ResourceType.GROUP,
                            itemid: group.userId,
                            _rankIndex: index,
                        } })); }),
                isLoading &&
                    Array(4)
                        .fill(0)
                        .map(function (_, index) { return (React.createElement(Placeholder, { key: index, className: s['grid-item'] })); })))));
};
GroupsBlock.displayName = 'GroupsBlock';
export default GroupsBlock;
//# sourceMappingURL=GroupsBlock.js.map